<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item :label="$t('EXPRESS_COMPANY_CODE')">
      <a-select
          style="width: 100%"
          v-model="form.data.expressCompanyCode">
        <!--        @change="handleChange">-->
        <a-select-option
            v-for="item in expressCompanyInfo"
            :key="item.code"
            :value="item.code">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item :label="$t('EXPRESS_NO')">
      <a-input v-model="form.data.expressNo"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button
            type="primary"
            v-if="!orderExpressId"
            @click="onAdd">{{ $t('CREATE') || '创建' }}
        </a-button>
        <a-button
            type="primary"
            v-if="orderExpressId"
            @click="onUpdate">{{ $t('UPDATE') || '创建' }}
        </a-button>
        <a-button @click="onCancel">{{ '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryWebsiteOrderExpress,
  _addWebsiteOrderExpress,
  _updateWebsiteOrderExpress,
  _queryWebsiteOrderExpressByOrderId,
} from '@/api/websiteOrderExpressApi';

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getOrderExpressList();
}

async function getOrderExpress() {
  console.log(this.orderExpressId)
  console.log(this.orderId)
  const result = await _queryWebsiteOrderExpressByOrderId(this.orderId);
  if (result) {
    this.form.data.expressNo = result.expressNo;
    this.form.data.expressCompanyCode = result.expressCompanyCode;
    this.form.data.sender = result.sender;
    this.form.data.mobile = result.phone;
  }
}

async function onAdd() {
  const result = await _addWebsiteOrderExpress({
    orderId: this.orderId,
    expressNo: this.form.data.expressNo,
    expressCompanyCode: this.form.data.expressCompanyCode,
    sender: this.form.data.sender,
    phone: this.form.data.mobile,
  });
  if (result) {
    if (this.onSubmitHandler) {
      this.$message.success(this.$t('ADD_SUCCESS'));
      this.onSubmitHandler();
    }
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateWebsiteOrderExpress(this.orderExpressId, {
        orderId: this.orderId,
        expressNo: this.form.data.expressNo,
        expressCompanyCode: this.form.data.expressCompanyCode,
        sender: this.form.data.sender,
        mobile: this.form.data.mobile,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteOrderExpressEdit',
  components: {},
  props: {
    orderExpressId: String,
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    orderExpressId() {
      if (this.orderExpressId) {
        this.getOrderExpress();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getOrderExpress,
  },
  data() {
    return {
      expressCompanyInfo: [
        {
          code: 'dhl',
          name: 'DHL中国件',
        },
        {
          code: 'dhlen',
          name: 'DHL全球件',
        },
        {
          code: 'shunfeng',
          name: '顺丰快递',
        }
      ],
      form: {
        data: {
          expressNo: '',
          expressCompanyCode: 'shunfeng',
          sender: '',
          mobile: '',
        },
        rules: {
          expressNo: [{
            required: true,
            trigger: 'blur',
          }],
          expressCompanyCode: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  created() {
    console.log(this.orderId)
    if (this.orderId) {
      this.getOrderExpress();
    }
  },
};
</script>
